import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['type', 'coaType', 'index', 'glAccountType']);
  const createCOA = `createCOA(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createCOA} {
      id
    }
  }
`;
};
